import React from 'react';

interface Props {
  warehouseAge: string;
}

function isStale(age: string): boolean {
  const hoursMatch = age.match(/^(\d+) hours? ago$/);
  if (hoursMatch) { return true; }
  const minutesMatch = age.match(/^(\d+) minutes? ago$/);
  if (minutesMatch) { return parseInt(minutesMatch[1], 10) > 45; }
  return false;
}

export function WarehouseAgeBadge({ warehouseAge }: Props) {
  const stale = isStale(warehouseAge);

  return (
    <span
      data-testid="warehouse-age-badge"
      style={{
        display: 'inline-block',
        padding: '0.25rem 0.6rem',
        borderRadius: '12px',
        fontSize: '0.78rem',
        fontWeight: 500,
        backgroundColor: stale ? '#fef3c7' : '#dcfce7',
        color: stale ? '#92400e' : '#166534',
        border: `1px solid ${stale ? '#fcd34d' : '#86efac'}`,
      }}
    >
      Last updated: {warehouseAge}
    </span>
  );
}
